import { ADD_USER, IS_DATA_MENU_OPEN, SET_DATA_VISIBILITY_ARRAY, SET_DATA_VISIBILITY_LIST, INITIALIZE_SET_BOUND_FNC, GET_NAVTEX_INFO, GET_DRILL_FLEET_LAST_LOCATIONS, SET_CHILDREN_LIST } from "./actions";
import { fromJS } from "immutable";
import { generateDynamicTemplate } from '../utils/helper';

const initialState = fromJS({
    isDataMenuOpen: false,
    users: [],//arr exp
    //dataVisibilities: [true, true, true, false, true, true, false, false],// vatan toprağı, mavi vatan, kktc, mavi Vatan Sınırları(accordion),libya anlaşması,kktc anlaşması, türk adaları, yunan adaları, karadeniz meb
    dataVisibilityList: { "anavatan": true, "mavivatan": true, "kktclandmap": true, "bluehomelandnegotiationlines": false, "trlibyakomsukiyilar": false, "countries": false, "trislands": false, "grislands": false, "blackseaeez": false, "acctoGreeceBorders": false, "straits": false, "MenteseAdalari": false },
    childrenData: {
        "bluehomelandNegotiationBorders": {//static content
            "visibilities": [true, true, true, true],
            "data": null
        },
        "countries": {//static content
            "visibilities": [true, true, true],
            "data": null
        },
        "accToGreeceBorders": {//static content sevilla map
            "visibilities": [false, false, false, false, false, false, false],
            "data": null
        },
        "straits": {
            "visibilities": [false, false, false, false, false, false],
            "data": null
        },
        "SaruhanAdalari": {
            "visibilities": [true],
            "data": null
        },
        "MenteseAdalari": {
            "visibilities": [true, true, true, true, true, true, true, true, true, true, true, true, true, true],
            "data": null
        },
        "drillShipsLastLocations": {//dynamic content service sonucunu taslağa dönüştür state'i güncelle
            "visibilities": null,
            "data": null
        },
        "navtexAreas": {//dynamic content
            "visibilities": null,
            "data": null
        }
    },
    filters: {//obj exp
        status: 'All',
        colors: []
    },
    loading: true,
    setBoundsDelegateFnc: false
    //newsList:[]
});
//TODO CHANGE NAME ROOTREDUCER
function rootReducer(state = initialState, action) {
    switch (action.type) {
        /*
        userData: {
            componentList: false
        }
        .setIn(['userData', 'currentStep'], action.currentStep);
        */
        case ADD_USER:
            return state.set("users", action.user);
        case IS_DATA_MENU_OPEN:
            return state.set("isDataMenuOpen", action.newStatus);
        case SET_DATA_VISIBILITY_ARRAY:
            return state.set("dataVisibilities", action.newDataSetArray);
        case SET_DATA_VISIBILITY_LIST:
            return state.set("dataVisibilityList", action.newDataList);
        case INITIALIZE_SET_BOUND_FNC:
            return state.set("setBoundsDelegateFnc", action.setBoundDelegate);
        case GET_NAVTEX_INFO:
            return state
                .setIn(['childrenData', 'navtexAreas'], generateDynamicTemplate(action.payload, "navtexAreas")) // action.payload
                .set("loading", false);
        case SET_CHILDREN_LIST:
            return state.set("childrenData", action.newChildrenList);
        case GET_DRILL_FLEET_LAST_LOCATIONS:
            return state
                .setIn(['childrenData', 'drillShipsLastLocations'], generateDynamicTemplate(action.payload, "drillShipsLastLocations")) // action.payload
                .set("loading", false);
        default:
            return state;
    }
}

export default rootReducer;